<template>
  <toast ref="toast" />

  <h2 class="container my-4">
    {{$t("user_settings.title_change_password")}}
  </h2>

  <section class="container my-4 d-flex">
    <a v-on:click="onPrevClick" class="btn btn-outline-success me-auto float-start">
      {{$t("buttons.return")}}
    </a>
    <a v-on:click="onUpdateClick" class="btn btn btn-outline-primary ms-2">
      {{$t("buttons.update")}}
    </a>
  </section>

  <section class="container my-4">
    <validation-errors class="alert alert-danger pb-0 overflow-hidden"
                       :errors="summaryErrors" />

    <basic-input ref="basic-input" type="password"
                 class="container my-4"
                 v-model="inputdata.currentPassword"
                 :attributes="attributes.CurrentPassword" />

    <basic-input ref="basic-input" type="password"
                 class="container my-4"
                 v-model="inputdata.newPassword"
                 :attributes="attributes.NewPassword" />
    <password-policy-modal ref="passwordPolicyModal" />

    <basic-input ref="basic-input" type="password"
                 class="container my-4"
                 v-model="inputdata.confirmPassword"
                 :attributes="attributes.ConfirmPassword" />
  </section>
</template>

<script>
  import { defineComponent } from "vue";
  import { xhrRequest, xhrErrors, xhrSummaryErrors } from "utils/xhr";
  import Spinner from "utils/spinner";
  import ValidationErrors from "components/base/validation_errors";
  import AlertToast from "components/toast/alert_toast";
  import PasswordPolicyModal from "components/modal/password_policy_modal";
  import BasicInput from "components/input/basic_input";

  const computed = {};

  const methods = {
    getAttributes() {
      const spinner = new Spinner();
      xhrRequest(
        "GET",
        "viewmodels/ChangePasswordViewModel",
        null,
        {
          success: data => {
            this.attributes = data;
          },
          error: (xhr, status, error) => {
            this.errors = xhrErrors(xhr);
            this.summaryErrors = xhrSummaryErrors(xhr);
          },
          complete: () => {
            spinner.stop();
            this.loading = false;
          }
        }
      );
    },
    validate() {
      if (this.loading) {
        return false;
      }
      this.loading = true;
      const spinner = new Spinner();
      xhrRequest(
        "POST",
        "users/PasswordValidate",
        this.inputdata,
        {
          success: data => {
            this.errors = {};
            this.summaryErrors = {};

            let confirmResult = true;

            if (this.userId !== null) {
              confirmResult = confirm(this.$t("messages.update_confirm"))
            }

            if (confirmResult) {
              this.update();
            }
          },
          error: (xhr, status, error) => {
            this.errors = xhrErrors(xhr);
            this.summaryErrors = xhrSummaryErrors(xhr);
          },
          complete: () => {
            spinner.stop();
            this.loading = false;
          }
        }
      );
    },
    update() {
      this.loading = true;
      let spinner = new Spinner();
      xhrRequest(
        "PUT",
        "users/ChangePassword",
        this.inputdata,
        {
          success: data => {
            // 通知を表示
            this.$refs.toast.storeToast({
              title: "",
              body: this.$t("messages.operation_completed", { operation: this.$t("buttons.update") }),
              isSimpleLayout: true,
            });

            // ToDo: 一般ユーザー向けメニュー画面への遷移
            window.location.href = "";
          },
          error: (xhr, status, error) => {
            this.errors = xhrErrors(xhr);
            this.summaryErrors = xhrSummaryErrors(xhr);
          },
          complete: () => {
            spinner.stop();
            this.loading = false;
          }
        }
      );
    },
    onPrevClick() {
      // ToDo: 一般ユーザー向けメニュー画面への遷移
      window.location.href = "";
    },
    onUpdateClick() {
      this.validate();
    },
    onPasswordPolicyClick() {
      this.$refs.passwordPolicyModal.openPasswordPolicyModal();
    },
  };

  const onInit =  () => {
  };

  const onMounted = function () {
    this.getAttributes();
  };

  export default defineComponent({
    template: "#container",
    data: () => {
      return {
        loading: false,
        inputdata: {
          currentPassword: "",
          newPassword: "",
          confirmPassword: "",
        },
        attributes: {},
        errors: {},
        summaryErrors: {},
      }
    },
    created: onInit,
    mounted: onMounted,
    methods: methods,
    computed: computed,
    components: {
      "validation-errors": ValidationErrors,
      "password-policy-modal": PasswordPolicyModal,
      "basic-input": BasicInput,
      "toast": AlertToast,
    },
  });
</script>
